'use client';

import type { ReactNode } from 'react';
import styled from 'styled-components';

import type { SpacingType } from '@zoomit/primitives';
import { Flex, Spacing } from '@zoomit/primitives';

type BreadcrumbsProps = {
  crumbs: {
    title: string;
    link?: string;
  }[];
  separator: string | ReactNode;
  render: (crumb: { title: string; link?: string; isLastItem: boolean; index: number }) => ReactNode;
  spacing?: SpacingType;
};

export const Breadcrumbs = ({ crumbs, render, separator, spacing = { my: 'x4' } }: BreadcrumbsProps) => {
  return (
    <Root spacing={spacing} alignItems="center" flexWrap="nowrap">
      {crumbs.map((crumb, index) => {
        const isLastItem = crumbs.length - 1 === index;

        return (
          <Flex
            key={`crumb-section-${index}`}
            flexWrap="nowrap"
            alignItems="center"
            gap={Spacing.x}
            spacing={{ pr: 'x' }}
            style={{ whiteSpace: 'nowrap' }}
          >
            {render({ ...crumb, isLastItem, index })}
            {!isLastItem && separator}
          </Flex>
        );
      })}
    </Root>
  );
};

const Root = styled(Flex)`
  font-size: 1.1rem;
  width: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }

  a {
    text-decoration: none;
    &.disabled {
      pointer-events: none;
    }
  }
`;

export default Breadcrumbs;
